const doc = [({"da":({"js":({"admin":({"user_elements":({"answer":({"this_answer_has_been_anonymized":"Dette svar er blevet anonymiseret.", "no_answer":"Intet svar givet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;